<template>

    <form class="needs-validation tab-pane fade" ref="form" :v-model="valid" lazy-validation autocomplete="off" novalidate id="signup-tab">
    <div class="form-group">
                <label for="su-name">Full name</label>
                <input class="form-control" v-model="name"
          :rules="nameRules"
          :counter="255"
          label="Name"
          type="text" id="su-name" placeholder="John Doe" required>
                <div class="invalid-feedback">Please fill in your name.</div>
              </div>
              <div class="form-group">
                <label for="su-email">Email address</label>
                <input class="form-control" v-model="email"
          :rules="emailRules"
          label="E-mail" type="email" id="su-email" placeholder="johndoe@example.com" required>
                <div class="invalid-feedback">Please provide a valid email address.</div>
              </div>
              <div class="form-group">
                <label for="su-password">Password</label>
                <div class="password-toggle">
                  <input class="form-control"  v-model="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="passwordRules"
          :type="showPassword ? 'text' : 'password'"
          label="Password"
          hint="At least 6 characters"
          counter
          @click:append="showPassword = !showPassword" id="su-password" required>
                  <!-- <label class="password-toggle-btn">
                    <input class="custom-control-input" type="checkbox"><i class="czi-eye password-toggle-indicator"></i><span class="sr-only">Show password</span>
                  </label> -->
                </div>
              </div>
              <!-- <div class="form-group">
                <label for="su-password-confirm">Confirm password</label>
                <div class="password-toggle">
                  <input class="form-control" type="password" id="su-password-confirm" required>
                  <label class="password-toggle-btn">
                    <input class="custom-control-input" type="checkbox"><i class="czi-eye password-toggle-indicator"></i><span class="sr-only">Show password</span>
                  </label>
                </div>
              </div> -->
              <button class="btn btn-primary btn-block btn-shadow" data-dismiss="modal" :disabled="!valid"
          @click="submit">Sign up</button>
          </form>
           
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'Register',
    data () {
        return {
            valid: true,
            name: '',
            nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 255) || 'Name must be less than 255 characters'
            ],
            email: '',
            emailRules: [
            v => !!v || 'E-mail is required',
            v => /([a-zA-Z0-9_]{1,})(@)([a-zA-Z0-9_]{2,}).([a-zA-Z0-9_]{2,})+/.test(v) || 'E-mail must be valid'
            ],
            showPassword: false,
            password: '',
            passwordRules: [
            v => !!v || 'Password required.',
            v => (v && v.length >= 6) || 'Min 6 characters',
            ],
            checkbox: false
        }
    },
    computed: {
      ...mapGetters({
        user  : 'auth/user',
      }),
    },
    methods: {
        ...mapActions({
          setAlert  : 'alert/set',
          setAuth   : 'auth/set',
        }),
        submit () {
            // if (this.$refs.form.validate()) {
                let formData = new FormData()
                formData.set('name', this.name)
                formData.set('email', this.email)
                formData.set('password', this.password)
                this.axios.post('/register', formData)
                    .then((response) => {
                        let { data } = response.data
                        this.setAuth(data)
                        this.setAlert({
                            status : true,
                            color  : 'success',
                            text  : 'Register success',
                        })
                        this.close()
                    })
                .catch((error) => {
                    let { data } = error.response
                    this.setAlert({
                        status : true,
                        color  : 'error',
                        text  : data.message,
                    })
                })
            // }
        },
        close() {
            this.$emit('closed', false)
        },
        clear () {
            this.$refs.form.reset()
        }
    },
    
}
</script>